var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06274 2.85531C9.02954 1.36144 10.7113 0.371094 12.6255 0.371094C15.5114 0.371094 17.8716 2.62186 18.0464 5.46373C18.104 5.46154 18.1618 5.46043 18.2199 5.46043C20.7046 5.46043 22.7188 7.47463 22.7188 9.95926C22.7188 12.4439 20.7046 14.4581 18.2199 14.4581L6.56492 14.4581C3.30785 14.4581 0.66748 11.8177 0.66748 8.56066C0.66748 5.3036 3.30785 2.66323 6.56492 2.66323C7.08175 2.66323 7.58387 2.72989 8.06274 2.85531ZM14.8579 8.1729C14.5925 8.50465 14.1084 8.55843 13.7767 8.29304L12.4623 7.24159V10.7693C12.4623 11.1941 12.118 11.5385 11.6931 11.5385C11.2683 11.5385 10.9239 11.1941 10.9239 10.7693V7.24155L9.60952 8.29304C9.27778 8.55843 8.79371 8.50464 8.52832 8.1729C8.26292 7.84116 8.31671 7.35709 8.64845 7.0917L11.2098 5.04262C11.3403 4.93708 11.5061 4.87338 11.6866 4.87188L11.6931 4.87186L11.6956 4.87186C11.8793 4.87244 12.0478 4.93742 12.1798 5.04539L14.7377 7.0917C15.0695 7.35709 15.1233 7.84116 14.8579 8.1729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/uploadCloud.e674cab1b427fe80af47d586a9946492.svg";
export { ForwardRef as ReactComponent };